/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_EmptyInputs */

const vi_reconcile_order_empty = /** @type {(inputs: Reconcile_Order_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy đơn phù hợp`)
};

/**

* @param {Reconcile_Order_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_empty = /** @type {((inputs?: Reconcile_Order_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_empty(inputs)
});